import { Fragment } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import HeaderCard from "../../../Components/Common/Component/HeaderCard";
import DataTableComponent from "../../../Components/Tables/DataTable/DataTableComponent";

export const SettingList = () => {

 
      
  return (
    <Fragment>
      <Breadcrumbs parent="Configuracion" title="Registros" mainTitle="Registros" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Administradores registrados" />
              <CardBody>
                <DataTableComponent />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}